export const TYPE = {
  png: 1,
  jpeg: 2,
  jpg: 3,
  pdf: 4,
  doc: 5,
  docx: 6,
  xls: 7,
  xlsx: 8,
  ppt: 9,
  pptx: 10,
};

export const TYPE_DATA = {
  [TYPE.png]: {
    id: TYPE.png,
    name: 'png',
    extension: '.png',
    mimeType: 'image/png',
  },
  [TYPE.jpeg]: {
    id: TYPE.jpeg,
    name: 'jpeg',
    extension: '.jpeg',
    mimeType: 'image/jpeg',
  },
  [TYPE.jpg]: {
    id: TYPE.jpg,
    name: 'jpg',
    extension: '.jpg',
    mimeType: 'image/jpg',
  },
  [TYPE.pdf]: {
    id: TYPE.pdf,
    name: 'pdf',
    extension: '.pdf',
    mimeType: 'application/pdf',
  },
  [TYPE.doc]: {
    id: TYPE.doc,
    name: 'doc',
    extension: '.doc',
    mimeType: 'application/msword',
  },
  [TYPE.docx]: {
    id: TYPE.docx,
    name: 'docx',
    extension: '.docx',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  [TYPE.xls]: {
    id: TYPE.xls,
    name: 'xls',
    extension: '.xls',
    mimeType: 'application/vnd.ms-excel',
  },
  [TYPE.xlsx]: {
    id: TYPE.xlsx,
    name: 'xlsx',
    extension: '.xlsx',
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  [TYPE.ppt]: {
    id: TYPE.ppt,
    name: 'ppt',
    extension: '.ppt',
    mimeType: 'application/vnd.ms-powerpoint',
  },
  [TYPE.pptx]: {
    id: TYPE.pptx,
    name: 'pptx',
    extension: '.pptx',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
};

const filesValues = Object.values(TYPE_DATA);

const imagesValues = [TYPE_DATA[TYPE.png], TYPE_DATA[TYPE.jpeg], TYPE_DATA[TYPE.jpg]];

export const EXTENSIONS = {
  files: {
    accept: filesValues.map((item) => item.mimeType).join(','),
    description: filesValues.map((item) => item.name).join(', '),
  },
  images: {
    accept: imagesValues.map((item) => item.mimeType).join(','),
    description: imagesValues.map((item) => item.name).join(', '),
  },
};
